<template>
  <div v-if="lowestSpecialPrice">
    Tämän tuotteen alin myyntihinta viimeisen 30 päivän aikana on ollut {{ eur(lowestSpecialPrice.inclTax) }} <span class="text-muted">({{ eur(lowestSpecialPrice.exclTax) }} alv. 0%)</span>
  </div>
</template>

<script setup lang="ts">
import { eur } from '~/helpers/filters'
import type { ProductAlgolia } from '~/types/product'

defineProps({
  lowestSpecialPrice: {
    type: Object as () => ProductAlgolia['lowestSpecialPrice'],
    required: true
  }
})
</script>
